import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue';
import { formatDateWeekdayPoint } from '@utils/dateTimeUtils';
import TravelDetails from '@lmt-rpb/TravelDetails/TravelDetails.vue';
import type { VerifiedFlightSegment, MergedOfferItemData } from '@interfaces/offer';
import { NBSP, NDASH } from '@global-js/constants';
import { useOfferVerifiedInjection } from '../injectionProps';
import TravelDateAttribute from '@lmt-rpb/Atoms/TravelDateAttribute/TravelDateAttribute.vue';

interface Props {
	offerData: MergedOfferItemData;
	outboundFlightSegments?: VerifiedFlightSegment[];
	inboundFlightSegments?: VerifiedFlightSegment[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedTravelDetails',
  props: {
    offerData: {},
    outboundFlightSegments: {},
    inboundFlightSegments: {}
  },
  setup(__props: any) {

const props = __props;
const { isPackage } = useOfferVerifiedInjection();
const formattedOutbound = computed(() => formatDateWeekdayPoint(props.offerData.StartDate));
const formattedInboundDate = computed(() => formatDateWeekdayPoint(props.offerData.EndDate));

const formattedText = computed(() => `${formattedOutbound.value}${NBSP}${NDASH}${NBSP}${formattedInboundDate.value}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["offer-verified__travel-details", { 'offer-verified__travel-details--hotel-only': !_unref(isPackage) }])
  }, [
    (_unref(isPackage))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(TravelDetails, {
            class: "offer-verified__travel-details-outbound",
            "unverified-date": _ctx.offerData.StartDate,
            "flight-segments": _ctx.outboundFlightSegments || [],
            flight: _ctx.offerData.OutboundFlight
          }, null, 8 /* PROPS */, ["unverified-date", "flight-segments", "flight"]),
          _createVNode(TravelDetails, {
            class: "offer-verified__travel-details-inbound",
            "unverified-date": _ctx.offerData.EndDate,
            "flight-segments": _ctx.inboundFlightSegments || [],
            flight: _ctx.offerData.InboundFlight,
            inbound: ""
          }, null, 8 /* PROPS */, ["unverified-date", "flight-segments", "flight"])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(TravelDateAttribute, {
          key: 1,
          icon: ['fa-regular', 'fa-calendar-range'],
          class: "offer-verified__hotel-only-outbound",
          text: formattedText.value
        }, null, 8 /* PROPS */, ["text"]))
  ], 2 /* CLASS */))
}
}

})